var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalChangeQtyData
        ? _c(
            "EmptyCardModal",
            {
              attrs: {
                modalData: _vm.modalChangeQtyData,
                onModalClose: (reset) => (_vm.modalChangeQtyData = null),
                onModalAccept: _vm.updateChangeQty,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _vm.modalChangeQtyData.type === "changeQty"
                    ? [
                        _c("ChangeQtyBlock", {
                          ref: "changeBlock",
                          attrs: {
                            hideRemain: true,
                            drug: _vm.modalChangeQtyData.drug,
                          },
                        }),
                      ]
                    : _vm._l(
                        _vm.modalChangeQtyData.detail.comments,
                        function (comment) {
                          return _c("div", { staticClass: "comment" }, [
                            _c("p", [_vm._v(_vm._s(comment.text))]),
                            _vm._v(" "),
                            comment.date
                              ? _c(
                                  "p",
                                  { staticClass: "text-muted text-right" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.printDate(comment.date)) + " "
                                    ),
                                    comment.user_name
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(comment.user_name) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        }
                      ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm table-hover" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("#")]),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            !_vm.hideEditDetails ? _c("th") : _vm._e(),
            _vm._v(" "),
            _vm.drugsImages ? _c("th") : _vm._e(),
            _vm._v(" "),
            _c("th", [_vm._v("Препарат")]),
            _vm._v(" "),
            _c("th", [_vm._v("Комментарий")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "100" } }, [_vm._v("Сверка")]),
            _vm._v(" "),
            _c("th", { attrs: { width: "175" } }, [_vm._v("Количество")]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.getSortedDetails(), function (detail, i) {
            return _c(
              "tr",
              {
                class: {
                  mark: false && detail.comments && detail.comments.length,
                },
              },
              [
                _c("td", [_vm._v(_vm._s(i + 1))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    detail.drug.cool
                      ? [_c("i", { staticClass: "icon icon-snowflake" })]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.hideEditDetails
                  ? _c(
                      "td",
                      [
                        detail.comments
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default comments_btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCommentBlock(detail)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-comments-o text-center",
                                  }),
                                  _vm._v(" "),
                                  detail.comments && detail.comments.length
                                    ? _c(
                                        "span",
                                        { staticClass: "badge badge-info" },
                                        [_vm._v(_vm._s(detail.comments.length))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.drugsImages
                  ? _c(
                      "td",
                      [
                        _vm.drugsImages[detail.drug_id]
                          ? _c(
                              "v-popover",
                              {
                                staticClass: "d-inline",
                                attrs: {
                                  placement: "bottom",
                                  "auto-hide": true,
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-photo pointer mr-1",
                                }),
                                _vm._v(" "),
                                _c("template", { slot: "popover" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.drugsImages[detail.drug_id],
                                      alt: "",
                                    },
                                  }),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("p", [_vm._v(_vm._s(detail.drug.title))]),
                    _vm._v(" "),
                    detail.drug.pack_comment
                      ? _c("p", { staticClass: "pack_comment" }, [
                          _vm._v(_vm._s(detail.drug.pack_comment)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    detail.drug.pack_box_comment
                      ? _c("p", { staticClass: "pack_box_comment" }, [
                          _vm._v(_vm._s(detail.drug.pack_box_comment)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    detail.drug.is_press_can
                      ? _c("p", { staticClass: "pack_box_comment" }, [
                          _c("span", { staticClass: "badge badge-danger" }, [
                            _vm._v("аэрозоль под давлением"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    Object.keys(detail.extra_data?.orders_comments ?? {}).length
                      ? [
                          _c("p", [_vm._v("Комментарии к заявкам")]),
                          _vm._v(" "),
                          _vm._l(
                            detail.extra_data.orders_comments,
                            function (comments, orderId) {
                              return _c(
                                "div",
                                { staticClass: "alert alert-info p-1 mb-1" },
                                [
                                  _c("p", [
                                    _vm._v("заявка: "),
                                    _c("strong", [_vm._v(_vm._s(orderId))]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(comments, function (c) {
                                    return _c("p", [_vm._v(_vm._s(c.text))])
                                  }),
                                ],
                                2
                              )
                            }
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("td"),
                _vm._v(" "),
                _c("td", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: detail.income_qty,
                        expression: "detail.income_qty",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: { value: detail.income_qty },
                    on: {
                      change: function ($event) {
                        return _vm.silentUpdateQty(detail)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(detail, "income_qty", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("td", [
                  !_vm.hideEditDetails
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-info btn-sm mr-2",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.openChangeDrugBlock(detail)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.printPackSet(detail.qty, detail.drug))),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }